export default "__VITE_PUBLIC_ASSET__949f7ec1__"